import React from "react";

import { Margins, Container, Column, Row, Skeleton } from "@ui/Atoms";

const SkeletonSlider = (): React.ReactElement => (
  <Margins xs={["base_x8", "base_x8", null, null]}>
    <Container>
      <Row>
        <Column xs={2}>
          <Skeleton shape="row" />
        </Column>
        <Column xs={8}>
          <Skeleton shape="row" />
        </Column>
        <Column xs={2}>
          <Skeleton shape="row" />
        </Column>
      </Row>
    </Container>
  </Margins>
);

export { SkeletonSlider };
